import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { BsThreeDots } from "react-icons/bs";
import { Table, Pagination } from "react-bootstrap";
import { MdFilterListAlt, MdFilterAltOff } from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;

function VisitingListings() {
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState({ status: "" });
  const [showFilter, setShowFilter] = useState(false);

  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const pageLimit = 10;

  const toggleFilter = () => setShowFilter((prev) => !prev);

  const showCustomMessageModal = (title, text, type) => {
    alert(`${title}: ${text}`);
  };

  const fetchVisits = async (page = 1) => {
    setLoading(true);
    try {
      const query = new URLSearchParams({
        page,
        status: searchTerm.status,
      }).toString();

      const response = await fetch(`${API_URL}/visite-list?${query}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await response.json();

      setVisits(result.data || []);
      setTotalPages(result.totalPages || 1);
      setCurrentPage(result.page || 1);
    } catch (error) {
      showCustomMessageModal("Error", "Failed to fetch visits.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVisits();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toSentenceCase = (text) => {
    if (!text) return "-";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      fetchVisits(pageNumber);
    }
  };

  const handleSearch = (e) => {
    if (e) e.preventDefault();
    fetchVisits(1);
  };

  const getPaginationGroup = () => {
    const start = Math.floor((currentPage - 1) / pageLimit) * pageLimit;
    return new Array(Math.min(pageLimit, totalPages - start))
      .fill()
      .map((_, idx) => start + idx + 1);
  };

  // ═══════════ INLINE STYLES ═══════════
  const gradientBg =
    "linear-gradient(135deg, #1e1b4b 0%, #3b0f6b 50%, #4c1d95 100%)";

  const styles = {
    searchInput: {
      flex: "1 1 220px",
      minWidth: 0,
      height: "44px",
      padding: "0 14px",
      fontSize: "13.5px",
      border: "1.5px solid #e2e8f0",
      borderRadius: "10px",
      background: "#fff",
      color: "#0f172a",
      outline: "none",
      boxSizing: "border-box",
      margin: 0,
      transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    },
    searchBtn: {
      flexShrink: 0,
      height: "44px",
      padding: "0 28px",
      fontSize: "13.5px",
      fontWeight: 700,
      color: "#fff",
      background: gradientBg,
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
      whiteSpace: "nowrap",
      boxShadow: "0 4px 14px rgba(76, 29, 149, 0.35)",
      transition: "all 0.22s ease",
      margin: 0,
    },
  };

  return (
    <div className="padding_15">
      <div className="userlist">
        <div className="card shadow-sm" style={{ borderRadius: "14px", overflow: "hidden" }}>
          {/* ═══════════ CARD HEADER ═══════════ */}
          <div
            className="card-header"
            style={{
              padding: "18px 24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "nowrap",
              background: gradientBg,
              borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
            }}
          >
            <div
              className="titlepage"
              style={{
                flex: "1 1 auto",
                minWidth: 0,
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: 700,
                  color: "#ffffff",
                  lineHeight: 1.35,
                  letterSpacing: "0.01em",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                title="Visiting Lists"
              >
                Visiting Lists
              </h3>
            </div>

            <div
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                flexShrink: 0,
              }}
            >
              <button
                type="button"
                onClick={toggleFilter}
                title={showFilter ? "Hide Filters" : "Show Filters"}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "40px",
                  height: "40px",
                  padding: 0,
                  border: "1px solid rgba(255, 255, 255, 0.18)",
                  background: showFilter
                    ? "#ffffff"
                    : "rgba(255, 255, 255, 0.12)",
                  color: showFilter ? "#1e1b4b" : "#ffffff",
                  borderRadius: "10px",
                  fontSize: "17px",
                  cursor: "pointer",
                  transition: "all 0.25s ease",
                  boxShadow: "none",
                  backdropFilter: "blur(8px)",
                  WebkitBackdropFilter: "blur(8px)",
                  flexShrink: 0,
                  outline: "none",
                }}
                onMouseEnter={(e) => {
                  if (!showFilter) {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.22)";
                    e.currentTarget.style.borderColor =
                      "rgba(255, 255, 255, 0.35)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!showFilter) {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.12)";
                    e.currentTarget.style.borderColor =
                      "rgba(255, 255, 255, 0.18)";
                  }
                }}
              >
                {showFilter ? <MdFilterAltOff /> : <MdFilterListAlt />}
              </button>
            </div>
          </div>

          {/* ═══════════ FILTER SECTION ═══════════ */}
          {showFilter && (
            <div className="card-body pb-0">
              <form
                onSubmit={handleSearch}
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "12px",
                  alignItems: "center",
                  marginBottom: "16px",
                  width: "100%",
                }}
              >
                <input
                  type="text"
                  name="status"
                  placeholder="Search By Status"
                  value={searchTerm.status}
                  onChange={(e) =>
                    setSearchTerm({
                      ...searchTerm,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={styles.searchInput}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = "#6366f1";
                    e.currentTarget.style.boxShadow =
                      "0 0 0 4px rgba(99, 102, 241, 0.12)";
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = "#e2e8f0";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                />

                <button
                  type="submit"
                  style={styles.searchBtn}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 20px rgba(76, 29, 149, 0.5)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 14px rgba(76, 29, 149, 0.35)";
                  }}
                >
                  Search
                </button>
              </form>
            </div>
          )}

          <div className="card-body">
            {loading ? (
              <p>Loading visits...</p>
            ) : (
              <>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Project Name</th>
                      <th>User Name</th>
                      <th>Vehicle Type</th>
                      <th>Total Duration</th>
                      <th>Total Distance</th>
                      <th>Total Amount</th>
                      <th>Visit Purpose</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visits.length === 0 ? (
                      <tr>
                        <td
                          colSpan="10"
                          className="text-center text-danger fw-bold"
                        >
                          Sorry, no data found!
                        </td>
                      </tr>
                    ) : (
                      visits.map((visit, index) => (
                        <tr key={visit.id}>
                          <td>{(currentPage - 1) * pageLimit + index + 1}</td>
                          <td>{toSentenceCase(visit.project_name)}</td>
                          <td>{toSentenceCase(visit.user_name)}</td>
                          <td>{toSentenceCase(visit.vehicle_type)}</td>
                          <td>
                            {Math.floor(visit.duration / 60)} min{" "}
                            {visit.duration % 60} sec
                          </td>
                          <td>
                            {(() => {
                              const m = Number(visit.distance);
                              return Number.isFinite(m)
                                ? (m / 1000).toFixed(2) + " (KM) "
                                : "—";
                            })()}
                          </td>
                          <td>₹ {parseFloat(visit.amount || 0).toFixed(2)}</td>
                          <td>
                            <div>{toSentenceCase(visit.visit_purpose)}</div>
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                visit.status?.toLowerCase() === "start"
                                  ? "bg-danger"
                                  : visit.status?.toLowerCase() === "end"
                                  ? "backgroundgreen"
                                  : "bg-secondary"
                              }`}
                            >
                              {toSentenceCase(visit.status)}
                            </span>
                          </td>
                          <td>
                            <div className="dropdown">
                              <button
                                className="btn light btn-action dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <BsThreeDots size={20} />
                              </button>
                              <ul className="dropdown-menu">
                                <li className="dropdown-item">
                                  <button
                                    className="btn view_btn btn-sm"
                                    title="View Details"
                                    onClick={() =>
                                      navigate(`/visitings-details/${visit.id}`)
                                    }
                                  >
                                    <FaEye /> View
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>

                {visits.length > 0 && (
                  <div className="d-flex justify-content-end">
                    <Pagination className="justify-content-center">
                      <Pagination.Prev
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      />
                      {getPaginationGroup().map((item, index) => (
                        <Pagination.Item
                          key={index}
                          active={item === currentPage}
                          onClick={() => handlePageChange(item)}
                        >
                          {item}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      />
                    </Pagination>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default VisitingListings;